import * as Styled from "./styled";

type CardFinanciProps = {
  text: string;
  value: string;
  variant?: string;
};

const CardFinanci = ({text, value, variant}: CardFinanciProps) => {
  return (
    <Styled.Container variant={variant}>
      <span>{text}</span>
      <Styled.ValueText variant={variant || "default"}>R$ {value}</Styled.ValueText>
    </Styled.Container>
  );
};

export default CardFinanci;